import Vue from 'vue'
import VueRouter from 'vue-router'
import { routes } from './routes.js'

import store from '../store'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: "active"
})

router.beforeEach((to, from, next) => {
  document.title = to.meta.title+' - mon compte assmat (49)'
  next()
})

router.beforeEach((to, from, next) => {
  if (to.matched.some((record) => record.meta.isPublic)) {
    next();
  } else {
    if (store.getters.isAuthenticated) {
      next();
      return;
    }
    next("/");
  }
});

export default router
